import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "min-w-[120px] lg:min-w-[281px] min-h-[56px] md:my-0 my-2 flex items-center justify-start lg:py-0 text-greyScale-900 font-medium rounded-md md:mr-3 text-[14px] md:text-base" }
const _hoisted_2 = { class: "ml-auto w-full md:w-auto flex items-center justify-start" }
const _hoisted_3 = ["value"]


import DeleteItemButton from './DeleteItemButton.vue';


export default {
  __name: 'MedicationItem',
  props: {
    id: {
        type: Number,
        required: true,
    },
    field: {
        type: Object,
        required: true,
    },
},
  emits: ['removeItem'],
  setup(__props, { emit }) {

const props = __props;





const remove = () => {
    emit('removeItem', props.id);
};

const mapValues = {
    '1x1': '1 opakowanie',
    '2x1': '2 opakowania',
    '3x1': '3 opakowania',
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, { class: "w-full bg-greyScale-50 md:h-[73px] pb-2 md:pb-0 rounded-lg pl-3 md:pl-8 pr-3 flex flex-col md:mb-0 md:flex-row md:items-center md:justify-start" }), [
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.field.title), 1),
    _createElementVNode("div", _hoisted_2, [
      (__props.field.variants && __props.field.variants !== 'custom')
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 0,
            class: "form-input !mt-0 mr-4 !h-[56px] w-full md:w-auto lg:min-w-[300px] !min-h-0",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((__props.field.selectedVariant) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.variants, (variant) => {
              return (_openBlock(), _createElementBlock("option", {
                value: variant.single_dosage
              }, _toDisplayString(mapValues[variant.single_dosage]), 9, _hoisted_3))
            }), 256))
          ], 512)), [
            [_vModelSelect, __props.field.selectedVariant]
          ])
        : _createCommentVNode("", true),
      (__props.field.variants === 'custom')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((__props.field.selectedVariant) = $event)),
            class: "form-input !mt-0 mr-4 !h-[56px] w-full md:w-auto lg:min-w-[350px] !min-h-0 px-2 overflow-visible",
            placeholder: 'Wpisz ilość opakowań/gramatu',
            min: 1
          }, null, 512)), [
            [_vModelText, __props.field.selectedVariant]
          ])
        : _createCommentVNode("", true),
      _createVNode(DeleteItemButton, {
        onDeleteItem: remove,
        id: __props.id
      }, null, 8, ["id"])
    ])
  ], 16))
}
}

}